import { render } from "./SingleChat.vue?vue&type=template&id=241f0a86&scoped=true"
import script from "./SingleChat.vue?vue&type=script&lang=js"
export * from "./SingleChat.vue?vue&type=script&lang=js"

import "./SingleChat.vue?vue&type=style&index=0&id=241f0a86&scoped=true&lang=css"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241f0a86"]])

export default __exports__